import Box from "@mui/material/Box";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";
import { useGetColorByValue } from "@/pages/diagnosticmonitor/hooks/useGetColorByValue";
import { safeLocale } from "@/utilities/i18n/safeLocale";

const dateOnlyOptions: Intl.DateTimeFormatOptions = {
  year: "numeric",
  month: "numeric",
  day: "numeric",
};

export function CalibrationCell(props: GridRenderCellParams) {
  const { i18n } = useTranslation();
  const getColorByValue = useGetColorByValue();
  const date = props.value as Date | undefined;
  const formatted = date ? date.toLocaleDateString(safeLocale(i18n.language), dateOnlyOptions) : "---";

  const { color, bgColor } = date
    ? getColorByValue(props.field, date.getTime())
    : { color: undefined, bgColor: undefined };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        height: "100%",
        color: bgColor ? color : undefined,
        backgroundColor: bgColor,
      }}
    >
      {formatted}
    </Box>
  );
}
